// extracted by mini-css-extract-plugin
export var content = "form-module--content--df859";
export var form = "form-module--form--f471a";
export var spin = "form-module--spin--4b683";
export var submit = "form-module--submit--75176";